export default __webpack_public_path__ + "static/Connect-541213519f4c96a5990e8a0935fb752c.png";